exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Cantarell:700,400|Raleway:400,500,700);", ""]);

// module
exports.push([module.id, "*{margin:0;padding:0;box-sizing:border-box;font-family:Cantarell;font-size:18px}blockquote,h1,h2,h3,h4,h5{font-family:Raleway;font-weight:400}a,a:visited{color:rgba(111,147,89,.9);text-decoration:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-31672fba","scoped":false,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/AdventureCampus.vue
// module id = 353
// module chunks = 0